import { Component, AfterContentInit, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import {
	Subscription, DataLoaderService, SummaryService,
	CommonDataService, PriceCalculationService, ProgressBarService
} from '../service-call-index';
import { SummaryValidationComponent } from '../summary-validations/summary-validations.component';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';
import { Utils } from '../../../../shared/utils';
import { element } from 'protractor';
declare let alasql: any;

@Component({
	selector: 'selected-options',
	templateUrl: './selected-options.template.html',
	styleUrls: ['./selected-options.component.css']
})

export class SelectedOptionsComponent implements AfterContentInit {
	public imageURL: String;
	public imageName: String;
	private selectedColor;
	private selectedAdditionalColor;
	private selectedTrim;
	private selectedRim;
	private selectedUpholstery;
	private hideToolTip = false;
    private tempImageName: string; 
	public classNames = ["MB+ACLASS", "MB+BCLASS", "MB+CCLASS", "MB+ECLASS", "MB+GCLASS", "MB+SCLASS", "MB+MCLASS"];

	public selectedNormalOptionsDictionary = {
		'selectedFactory': [], 'selectedLocal': [], 'selectedPackage': [], 'selectedLocalPackage': [], 'standardOptions': []
	}
	public editIconDictionary = {
		'showColorEditIcon': true, 'showAddColorEditIcon': true, 'showRimEditIcon': true, 'showTrimEditIcon': true, 'showFactoryEditIcon': true,
		'showLocalEditIcon': true, 'showPackageEditIcon': true, 'showUpholsteryEditIcon': true
	}
	public expandOptionDictionary = {
		'expandFactoryOptions': false, 'expandStandardOptions': false, 'expandLocalOptions': false, 'expandPackageOptions': false
	}
	public subscription: Subscription;
	public vehicleDetails: any; any; vehClass: string; tempVehClass: string;
	public currency: string;
	public arrow = "right";
	public icon = "gray";
	public vehicleInfo: any;


	constructor(private commonDataService: CommonDataService, private vehicleInfoService: VehicleInfoService,private priceService: PriceCalculationService,
		private dataLoaderService: DataLoaderService, private progressService: ProgressBarService,
		private cdr: ChangeDetectorRef, private apr: ApplicationRef,
		private summaryService: SummaryService, private summaryValidationComponent: SummaryValidationComponent) {
		this.vehicleInfo = this.vehicleInfoService.extractData();
		if (this.dataLoaderService.vehicleInfo.vehicleClass === "MB+GLCLASS+") {
			this.vehClass = this.dataLoaderService.vehicleInfo.vehicleClass.split('+')[1];
			this.tempVehClass = this.vehClass.substring(0, 2) + '-' + this.vehClass.substring(2, 7);
		}
		else if (this.dataLoaderService.vehicleInfo.vehicleClass === "SMART") {
			this.tempVehClass = this.dataLoaderService.vehicleInfo.vehicleClass;
		}
		else {
			let count = 0;
			for (let i in this.classNames) {
				if (this.dataLoaderService.vehicleInfo.vehicleClass == this.classNames[i]) {
					this.vehClass = this.dataLoaderService.vehicleInfo.vehicleClass.split('+')[1];
					this.tempVehClass = this.vehClass[0] + '-' + this.vehClass.substring(1, 6);
					count++;
				}
			}
			if (count == 0) {
				this.tempVehClass = undefined;
			}

		}
		this.vehicleDetails = this.dataLoaderService.data.vehInfo;
		// this.priceService.priceDictionary.globalPrice = this.dataLoaderService.data.vehInfo[0].priceBpmBm;

		//Japan Change - Add ¥ currency symbol instead of JPY
		if (this.dataLoaderService.data.currencyType == "JPY") {
			this.dataLoaderService.data.currencyType = "¥";
		}
		this.currency = this.dataLoaderService.data.currencyType;
		this.loadDataFor0();
	}

	loadDataFor0() {
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0') {
			if( Utils.isCountryCA_N(this.vehicleInfo.orderingMarket)  || Utils.isCountryCA_T(this.vehicleInfo.orderingMarket)){
				//default color options
				this.dataLoaderService.data.color.forEach(element => {
					if(element.selected === true){
						this.selectedColor = element;
					}
				});this.commonDataService.progressBarNewOrderColorFlag = true;
				this.dataLoaderService.flagDictionary.defaultColorFlag = false;
				this.priceService.notifyNormalCompItem({fromComponent: "normalColor", data:this.selectedColor});

				// default additional color options
				if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT'){
					this.dataLoaderService.data.additionalColor.forEach(element => {
						if (element.selected === true) {
							this.selectedAdditionalColor = element;
						}
					});
					this.dataLoaderService.flagDictionary.defaultAddColorFlag = false;
					this.priceService.notifyNormalCompItem({fromComponent: "normalAddColor", data:this.selectedAdditionalColor});
				}

				//derfault upholstery options
				this.dataLoaderService.data.upholstery.forEach(element => {
					if (element.selected === true) {
						this.selectedUpholstery = element;
					}
				});
				this.commonDataService.progressBarNewOrderUpholsteryFlag = true;
				this.dataLoaderService.flagDictionary.defaultUpholsteryFlag = false;
				this.priceService.notifyNormalCompItem({fromComponent: "normalUpholstery", data:this.selectedUpholstery});
			

			//default rim options
			this.dataLoaderService.data.rim.forEach(element => {
				if (element.selected === true) {
					this.selectedRim = element;
				}
			});
			this.dataLoaderService.flagDictionary.defaultRimFlag = false;
			this.priceService.notifyNormalCompItem({ fromComponent: "normalRim", data: this.selectedRim });

			//default trim options
			this.dataLoaderService.data.trim.forEach(element => {
				if (element.selected === true) {
					this.selectedTrim = element;
				}
			});
			this.dataLoaderService.flagDictionary.defaultTrimFlag = false;
			this.priceService.notifyNormalCompItem({ fromComponent: "normalTrim", data: this.selectedTrim });

			//default standard options
			this.dataLoaderService.data.stdOpt.forEach(element => {
				if (element.selected === true) {
					this.selectedNormalOptionsDictionary.standardOptions.push(element);
				}
			});
			this.priceService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.selectedNormalOptionsDictionary.standardOptions] });
			// default factory options
			this.dataLoaderService.data.facOptions.forEach(element => {
				if (element.selected === true) {
					this.selectedNormalOptionsDictionary.selectedFactory.push(element);
				}
			});
			this.dataLoaderService.flagDictionary.defaultFactoryFlag = false;
			this.priceService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.selectedNormalOptionsDictionary.selectedFactory] });

			// default local options
			this.dataLoaderService.data.options.forEach(element => {
				if (element.selected === true) {
					this.selectedNormalOptionsDictionary.selectedLocal.push(element);
				}
			});
			this.dataLoaderService.flagDictionary.defaultLocalOptionsFlag = false;
			this.priceService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.selectedNormalOptionsDictionary.selectedLocal] });

			// default package options
			this.dataLoaderService.data.packages.forEach(element => {
				if (element.selected === true) {
					this.selectedNormalOptionsDictionary.selectedPackage.push(element);
				}
			});
			this.dataLoaderService.flagDictionary.defaultPackageOptionsFlag = false;
			this.priceService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.selectedNormalOptionsDictionary.selectedPackage] });

			// default local package options
			this.dataLoaderService.data.localPackagesList.forEach(element => {
				if (element.selected === true) {
					this.selectedNormalOptionsDictionary.selectedLocalPackage.push(element);
				}
			});

			}

			if( !(Utils.isCountryCA_N(this.vehicleInfo.orderingMarket))  || !(Utils.isCountryCA_T(this.vehicleInfo.orderingMarket))){
			//default color options
			this.dataLoaderService.data.color.forEach(element => {
				if(element.selected === true){
					this.selectedColor = element;
				}
			});this.commonDataService.progressBarNewOrderColorFlag = true;
			this.dataLoaderService.flagDictionary.defaultColorFlag = false;
			this.priceService.notifyNormalCompItem({fromComponent: "normalColor", data:this.selectedColor});

			// default additional color options
			if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT'){
				this.dataLoaderService.data.additionalColor.forEach(element => {
					if (element.selected === true) {
						this.selectedAdditionalColor = element;
					}
				});
				this.dataLoaderService.flagDictionary.defaultAddColorFlag = false;
				this.priceService.notifyNormalCompItem({fromComponent: "normalAddColor", data:this.selectedAdditionalColor});
			}

			//derfault upholstery options
			this.dataLoaderService.data.upholstery.forEach(element => {
				if (element.selected === true) {
					this.selectedUpholstery = element;
				}
			});
			this.commonDataService.progressBarNewOrderUpholsteryFlag = true;
			this.dataLoaderService.flagDictionary.defaultUpholsteryFlag = false;
			this.priceService.notifyNormalCompItem({fromComponent: "normalUpholstery", data:this.selectedUpholstery});
		

		//default rim options
		this.dataLoaderService.data.rim.forEach(element => {
			if (element.selected === true) {
				this.selectedRim = element;
			}
		});
		this.dataLoaderService.flagDictionary.defaultRimFlag = false;
		this.priceService.notifyNormalCompItem({ fromComponent: "normalRim", data: this.selectedRim });

		//default trim options
		this.dataLoaderService.data.trim.forEach(element => {
			if (element.selected === true) {
				this.selectedTrim = element;
			}
		});
		this.dataLoaderService.flagDictionary.defaultTrimFlag = false;
		this.priceService.notifyNormalCompItem({ fromComponent: "normalTrim", data: this.selectedTrim });

		//default standard options
		this.dataLoaderService.data.stdOpt.forEach(element => {
			if (element.selected === true) {
				this.selectedNormalOptionsDictionary.standardOptions.push(element);
			}
		});
		this.priceService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.selectedNormalOptionsDictionary.standardOptions] });
		// default factory options
		this.dataLoaderService.data.facOptions.forEach(element => {
			if (element.selected === true) {
				this.selectedNormalOptionsDictionary.selectedFactory.push(element);
			}
		});
		this.dataLoaderService.flagDictionary.defaultFactoryFlag = false;
		this.priceService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.selectedNormalOptionsDictionary.selectedFactory] });

		// default local options
		this.dataLoaderService.data.options.forEach(element => {
			if (element.selected === true) {
				this.selectedNormalOptionsDictionary.selectedLocal.push(element);
			}
		});
		this.dataLoaderService.flagDictionary.defaultLocalOptionsFlag = false;
		this.priceService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.selectedNormalOptionsDictionary.selectedLocal] });

		// default package options
		this.dataLoaderService.data.packages.forEach(element => {
			if (element.selected === true) {
				this.selectedNormalOptionsDictionary.selectedPackage.push(element);
			}
		});
		this.dataLoaderService.flagDictionary.defaultPackageOptionsFlag = false;
		this.priceService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.selectedNormalOptionsDictionary.selectedPackage] });

		// default local package options
		this.dataLoaderService.data.localPackagesList.forEach(element => {
			if (element.selected === true) {
				this.selectedNormalOptionsDictionary.selectedLocalPackage.push(element);
			}
		});
	}

			this.priceService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.selectedNormalOptionsDictionary.selectedLocalPackage] });
		}
		this.priceService.normalModePriceCalculation();
	}

	ngAfterContentInit() {
		this.getSelectedOptions();

		if (this.dataLoaderService.vehicleInfo.urlFlag === '2' || this.dataLoaderService.vehicleInfo.urlFlag === '1' || this.dataLoaderService.vehicleInfo.urlFlag === '3') {
			this.getAmendData();
		}
	}
	getAmendData() {
		//standard option
		for (let i in this.dataLoaderService.data.stdOpt) {
			if (this.dataLoaderService.data.stdOpt[i].selected === true) {
				this.selectedNormalOptionsDictionary.standardOptions.unshift(this.dataLoaderService.data.stdOpt[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.selectedNormalOptionsDictionary.standardOptions] });
		this.priceService.notifyNormalCompItem({ fromComponent: "expertStandard", data: this.selectedNormalOptionsDictionary.standardOptions });

		// color
		for (let i in this.dataLoaderService.data.color) {
			if (this.dataLoaderService.data.color[i].selected === true) {
				this.selectedColor = this.dataLoaderService.data.color[i];
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalColor", data: [this.selectedColor] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertColor", data: [this.selectedColor] });

		//Additional color
		for (let i in this.dataLoaderService.data.additionalColor) {
			if (this.dataLoaderService.data.additionalColor[i].selected === true) {
				this.selectedAdditionalColor = this.dataLoaderService.data.additionalColor[i];
			}
		}

		this.priceService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [this.selectedAdditionalColor] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: this.selectedAdditionalColor });

		//Trim
		for (let i in this.dataLoaderService.data.trim) {
			if (this.dataLoaderService.data.trim[i].selected === true) {
				this.selectedTrim = this.dataLoaderService.data.trim[i];
			}
		}
		if (this.selectedTrim != undefined) {
			this.priceService.notifyNormalCompItem({ fromComponent: "normalTrim", data: [this.selectedTrim] });
			this.priceService.notifyExpertCompItem({ fromComponent: "expertTrim", data: this.selectedTrim });
		}


		//Rim 
		for (let i in this.dataLoaderService.data.rim) {
			if (this.dataLoaderService.data.rim[i].selected === true) {
				this.selectedRim = this.dataLoaderService.data.rim[i];
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalRim", data: [this.selectedRim] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertRim", data: [this.selectedRim] });

		//Upholstery
		for (let i in this.dataLoaderService.data.upholstery) {
			if (this.dataLoaderService.data.upholstery[i].selected === true) {
				this.selectedUpholstery = this.dataLoaderService.data.upholstery[i];
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [this.selectedUpholstery] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: this.selectedUpholstery });

		//Factory Options
		for (let i in this.dataLoaderService.data.facOptions) {
			if (this.dataLoaderService.data.facOptions[i].selected === true) {
				this.selectedNormalOptionsDictionary.selectedFactory.unshift(this.dataLoaderService.data.facOptions[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.selectedNormalOptionsDictionary.selectedFactory] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertFactory", data: this.selectedNormalOptionsDictionary.selectedFactory });

		//Local Options
		for (let i in this.dataLoaderService.data.options) {
			if (this.dataLoaderService.data.options[i].selected === true) {
				this.selectedNormalOptionsDictionary.selectedLocal.unshift(this.dataLoaderService.data.options[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.selectedNormalOptionsDictionary.selectedLocal] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertLocal", data: this.selectedNormalOptionsDictionary.selectedLocal });

		//Package options
		for (let i in this.dataLoaderService.data.packages) {
			if (this.dataLoaderService.data.packages[i].selected === true) {
				this.selectedNormalOptionsDictionary.selectedPackage.unshift(this.dataLoaderService.data.packages[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.selectedNormalOptionsDictionary.selectedPackage] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertPackage", data: this.selectedNormalOptionsDictionary.selectedPackage });

		//Local Package Options
		for (let i in this.dataLoaderService.data.localPackagesList) {
			if (this.dataLoaderService.data.localPackagesList[i].selected === true) {
				this.selectedNormalOptionsDictionary.selectedLocalPackage.unshift(this.dataLoaderService.data.localPackagesList[i]);
			}
		}
		this.priceService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.selectedNormalOptionsDictionary.selectedLocalPackage] });
		this.priceService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: this.selectedNormalOptionsDictionary.selectedLocalPackage });

		// Price calculation
		this.priceService.normalModePriceCalculation();

		//For traffic lights
		this.progressService.progressBarValidation();
	}

	getSelectedOptions() {
		this.subscription = this.commonDataService.getSelectedClass().subscribe(selectedOption => {
			this.imageURL = selectedOption;
		});
		this.subscription = this.commonDataService.getSelectedClassName().subscribe(selectedOption => {
			this.imageName = selectedOption;
			// changes for tooltip
			if (this.imageName.length <= 40){
				this.hideToolTip = true;
				document.getElementById('desc-holder').style.height = '82px';
			  } else {
				this.tempImageName = this.imageName.substring(0, 37) + "...";
				this.hideToolTip = false;
			  }
		});
		setTimeout(() =>
			this.subscription = this.priceService.notifyObservableNormalComp$.subscribe((selectedOption) => {
				if (selectedOption.fromComponent == "normalColor") {
					if (selectedOption.data[0] != undefined) {
						this.selectedColor = selectedOption.data[0];
					} else {
						if (selectedOption.data != undefined) {
							this.selectedColor = selectedOption.data;
						}
					}
				} else if (selectedOption.fromComponent == "normalAddColor") {
					if (selectedOption.data[0] != undefined) {
						this.selectedAdditionalColor = selectedOption.data[0];
					} else {
						if (selectedOption.data != undefined) {
							this.selectedAdditionalColor = selectedOption.data;

						}
					}
				} else if (selectedOption.fromComponent == "normalTrim") {
					if (selectedOption.data[0] != undefined) {
						this.selectedTrim = selectedOption.data[0];
					} else {
						if (selectedOption.data != undefined) {
							let temp = [];
							temp.push(selectedOption.data);
							if (temp[0].length == 0) {
								this.selectedTrim = undefined;
							} else {
								this.selectedTrim = selectedOption.data;
							}
						}
					}
				} else if (selectedOption.fromComponent == "normalRim") {
					if (selectedOption.data[0] != undefined) {
						this.selectedRim = selectedOption.data[0];
					} else {
						if (selectedOption.data != undefined) {
							this.selectedRim = selectedOption.data;
						}
					}
				} else if (selectedOption.fromComponent == "normalUpholstery") {
					if (selectedOption.data[0] != undefined) {
						this.selectedUpholstery = selectedOption.data[0];
					} else {
						if (selectedOption.data != undefined) {
							this.selectedUpholstery = selectedOption.data;
						}
					}
				} else if (selectedOption.fromComponent == "normalFactory") {
					this.selectedNormalOptionsDictionary.selectedFactory = (selectedOption.data[0]);
					this.cdr.detectChanges();
				} else if (selectedOption.fromComponent == "normalLocal") {
					this.selectedNormalOptionsDictionary.selectedLocal = (selectedOption.data[0]);
					this.cdr.detectChanges();
				} else if (selectedOption.fromComponent == "normalPackage") {
					this.selectedNormalOptionsDictionary.selectedPackage = (selectedOption.data[0]);
					for (let i in this.selectedNormalOptionsDictionary.selectedPackage) {
						if (this.selectedNormalOptionsDictionary.selectedPackage[i].selected == false) {
							this.selectedNormalOptionsDictionary.selectedPackage.splice(Number(i), 1);
						}
					}
					this.cdr.detectChanges();
				} else if (selectedOption.fromComponent == "normalLocalPackage") {
					this.selectedNormalOptionsDictionary.selectedLocalPackage = (selectedOption.data[0]);
					for (let i in this.selectedNormalOptionsDictionary.selectedLocalPackage) {
						if (this.selectedNormalOptionsDictionary.selectedLocalPackage[i].selected == false) {
							this.selectedNormalOptionsDictionary.selectedLocalPackage.splice(Number(i), 1);
						}
					}
					if (this.selectedNormalOptionsDictionary.selectedLocalPackage != undefined) {
						this.selectedNormalOptionsDictionary.selectedLocalPackage = this.selectedNormalOptionsDictionary.selectedLocalPackage.filter((el, i, a) => i === a.indexOf(el));
						this.cdr.detectChanges();
					}
				} else if (selectedOption.fromComponent == "normalStandard") {
					this.selectedNormalOptionsDictionary.standardOptions = (selectedOption.data[0]);
					this.cdr.detectChanges();
				}
			})

		)

	}

	showEdit(id) {
		if (id == 'colorEdit') {
			this.editIconDictionary.showColorEditIcon = false;
			this.cdr.detectChanges();
		}
		else if (id == 'addColorEdit') {
			this.editIconDictionary.showAddColorEditIcon = false;
			this.cdr.detectChanges();
		}
		else if (id == 'upholsteryEdit') {
			this.editIconDictionary.showUpholsteryEditIcon = false;
			this.cdr.detectChanges();
		}
		else if (id == 'trimEdit') {
			this.editIconDictionary.showTrimEditIcon = false;
			this.cdr.detectChanges();
		}
		else if (id == 'rimEdit') {
			this.editIconDictionary.showRimEditIcon = false;
			this.cdr.detectChanges();
		}
		else if (id == 'factoryEdit') {
			this.editIconDictionary.showFactoryEditIcon = false;
			this.cdr.detectChanges();
		}
		else if (id == 'localEdit') {
			this.editIconDictionary.showLocalEditIcon = false;
			this.cdr.detectChanges();

		}
		else if (id == 'PackageEdit') {
			this.editIconDictionary.showPackageEditIcon = false;
			this.cdr.detectChanges();
		}

	}
	hideEdit(id) {
		if (id == 'colorEdit') {
			this.editIconDictionary.showColorEditIcon = true;
			this.cdr.detectChanges();
		}
		else if (id == 'addColorEdit') {
			this.editIconDictionary.showAddColorEditIcon = true;
			this.cdr.detectChanges();
		}
		else if (id == 'upholsteryEdit') {
			this.editIconDictionary.showUpholsteryEditIcon = true;
			this.cdr.detectChanges();
		}
		else if (id == 'trimEdit') {
			this.editIconDictionary.showTrimEditIcon = true;
			this.cdr.detectChanges();
		} else if (id == 'rimEdit') {
			this.editIconDictionary.showRimEditIcon = true;
			this.cdr.detectChanges();
		}
		else if (id == 'factoryEdit') {
			this.editIconDictionary.showFactoryEditIcon = true;
			this.cdr.detectChanges();
		}
		else if (id == 'localEdit') {
			this.editIconDictionary.showLocalEditIcon = true;
			this.cdr.detectChanges();
		}
		else if (id == 'PackageEdit') {
			this.editIconDictionary.showPackageEditIcon = true;
			this.cdr.detectChanges();
		}
	}
	expandFactoryOptionsFunc() {
		//this.cdr.detectChanges();
		this.expandOptionDictionary.expandFactoryOptions = !this.expandOptionDictionary.expandFactoryOptions;
		this.cdr.detectChanges();
	}
	expandStandardOptionsFunc() {
		this.expandOptionDictionary.expandStandardOptions = !this.expandOptionDictionary.expandStandardOptions;
	}
	expandLocalOptionsFunc() {
		this.expandOptionDictionary.expandLocalOptions = !this.expandOptionDictionary.expandLocalOptions;
	}
	expandPackageOptionsFunc() {
		this.expandOptionDictionary.expandPackageOptions = !this.expandOptionDictionary.expandPackageOptions;
	}

	backToComponent(id) {
		if (id === 'editIconColor') {
			this.commonDataService.notifyOther({ option: 'defaultOpen' });
			this.commonDataService.setColorFlag();
		}
		else if (id === 'editIconAddColor') {
			this.commonDataService.notifyOther({ option: 'activeAddColor' });
			this.commonDataService.setAddColorFlag();
		}
		else if (id === 'editIconUpholstery') {
			this.commonDataService.notifyOther({ option: 'activeUpholstery' });
			this.commonDataService.setUpholsteryFlag();
		}
		else if (id === 'editIconTrim') {
			this.commonDataService.notifyOther({ option: 'activeTrim' });
			this.commonDataService.setTrimFlag();
		}
		else if (id === 'editIconRim') {
			this.commonDataService.notifyOther({ option: 'activeRim' });
			this.commonDataService.setRimFlag();
		}
		else if (id === 'editIconFactory') {
			this.commonDataService.notifyOther({ option: 'activeFactory' });
			this.commonDataService.setFactoryFlag();
			//this.cdr.detectChanges();
		}
		else if (id === 'editIconLocal') {
			this.commonDataService.notifyOther({ option: 'activeLocal' });
			this.commonDataService.setLocalFlag();
		}
		else if (id === 'editIconPackage') {
			this.commonDataService.notifyOther({ option: 'activePackage' });
			this.commonDataService.setPackageFlag();

		}
	}

	openSuccessMesssage() {
		if (this.dataLoaderService.vehicleInfo.urlFlag == '0' || this.dataLoaderService.vehicleInfo.urlFlag == '1') {
			this.submitData();

		}
		if (this.dataLoaderService.vehicleInfo.urlFlag == '2' || this.dataLoaderService.vehicleInfo.urlFlag == '3') {
			if (!this.dataLoaderService.flagDictionary.validated) {
				this.summaryValidationComponent.alternateOptionsForURLFlag2Accept();
			}
			else {
				this.submitData();
			}
		}
	}

	validateConfiguration() {
		this.dataLoaderService.flagDictionary.loadingFlag = true;
		if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT'  && this.dataLoaderService.data.additionalColor.length > 0) {
			if ( (this.selectedColor.length === 0 && this.selectedUpholstery.length === 0 && this.selectedAdditionalColor.length === 0) || 
			(this.selectedColor === undefined && this.selectedUpholstery === undefined && this.selectedAdditionalColor === undefined) || 
			(this.selectedColor.length !== 0 && this.selectedUpholstery.length === 0 && this.selectedAdditionalColor.length === 0) ||
			(this.selectedColor.length === 0 && this.selectedUpholstery.length !== 0 && this.selectedAdditionalColor.length === 0) ||
			(this.selectedColor.length === 0 && this.selectedUpholstery.length === 0 && this.selectedAdditionalColor.length !== 0) ||
			(this.selectedColor.length !== 0 && this.selectedUpholstery.length !== 0 && this.selectedAdditionalColor.length === 0) ||
			(this.selectedColor.length !== 0 && this.selectedUpholstery.length === 0 && this.selectedAdditionalColor.length !== 0) ||
			(this.selectedColor.length === 0 && this.selectedUpholstery.length !== 0 && this.selectedAdditionalColor.length !== 0)) {
				this.dataLoaderService.flagDictionary.summaryFlag = true;
				this.dataLoaderService.flagDictionary.errorFlag = true;
				this.dataLoaderService.flagDictionary.successFlag = false;
				this.dataLoaderService.flagDictionary.loadingFlag = false;
			}
			else {
				this.openSuccessMesssage();
				this.dataLoaderService.flagDictionary.summaryFlag = true;
				this.dataLoaderService.flagDictionary.successFlag = true;
				this.dataLoaderService.flagDictionary.errorFlag = false;
			}
		}
		else {
			if ((!this.selectedColor && !this.selectedUpholstery) || 
			(this.selectedColor == undefined && this.selectedUpholstery == undefined) || 
			(this.selectedColor !==[]  && this.selectedUpholstery == undefined) ||
			(this.selectedUpholstery!==[]  && this.selectedColor == undefined) ||
			(this.selectedColor.length == 0 && this.selectedUpholstery.length == 0) || 
			(this.selectedUpholstery.length == 0 && this.selectedColor.length !== 0 ) ||  
			(this.selectedColor.length == 0 && this.selectedUpholstery.length !== 0 )) {
				this.dataLoaderService.flagDictionary.summaryFlag = true;
				this.dataLoaderService.flagDictionary.errorFlag = true;
				this.dataLoaderService.flagDictionary.successFlag = false;
				this.dataLoaderService.flagDictionary.loadingFlag = false;


			}
			else {

				this.openSuccessMesssage();
				this.dataLoaderService.flagDictionary.summaryFlag = true;
				this.dataLoaderService.flagDictionary.successFlag = true;
				this.dataLoaderService.flagDictionary.errorFlag = false;
				this.dataLoaderService.flagDictionary.loadingFlag = false;
			}
		}
	}
	submitData() {

		if(this.dataLoaderService.vehicleInfo.urlFlag == '2' || this.dataLoaderService.vehicleInfo.urlFlag == '3'){

		let configData = this.summaryService.submitDataNew();
		console.log("SWT_Config_Data ---New--- ",configData);
		(<HTMLInputElement>document.getElementById('acceptString')).value = configData + '';
		(<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
		(<HTMLFormElement>document.getElementById('form1')).submit();
		}
		else{
		let configData = this.summaryService.submitData();
		console.log("SWT_Config_Data ---Old--- ",configData);
		(<HTMLInputElement>document.getElementById('acceptString')).value = configData + '';
		(<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
		(<HTMLFormElement>document.getElementById('form1')).submit();

		}
		
		
	}

	/**
	 * For printing the summary page
	 * @param none
	 * @returns none
	 */
	printSummary() {
		this.summaryService.printSelectedData();
	}
	/**
	 * To export the summary to Excel
	 * @param none
	 * @returns none
	 */
	exportToExcel() {
		this.summaryService.exportSelectedDataToExcel();
	}
}





// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/selected-options/selected-options.component.ts